// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"bc9734b2","548":"5e7bcfcc","782":"243778de","868":"f0c2cf98"}[chunkId] + ".chunk.css";
};